import { FunctionComponent } from "react";
import { FocusableComponentLayout, useFocusable } from "../../../../../modules/spatialNavigation";
import { ElasticTag } from "../../../../../modules/graphql/api.generated";
import { NavLink, useHistory } from "react-router-dom";
import * as styles from "./styles.module.scss";
interface IProps {
  focusKey: string;
  onFocus: (l: FocusableComponentLayout, tag: ElasticTag) => void;
  data: ElasticTag;
}
const TagItem: FunctionComponent<IProps> = (props) => {
  const history = useHistory();
  const { ref, focused } = useFocusable({
    saveLastFocusedChild: false,
    onEnterPress: () => {
      history.push("/t/" + props.data.descriptor);
    },
    onFocus: (l: FocusableComponentLayout) => {
      return props.onFocus(l, props.data);
    },
  });
  return (
    <NavLink
      dir="rtl"
      className={`${styles.tagItem} ${focused ? styles.focusedTag : ""}`}
      to={`/t/${props.data.descriptor}`}
      ref={ref}
    >
      {props.data.name}
    </NavLink>
  );
};
export default TagItem;
